<p-tieredMenu #menu [appendTo]="internalOptions.minimized ? 'body' : ''" [model]="languageOptions" [popup]="true" />

@if (!internalOptions.minimized) {
    <div
        class="mx-3 flex h-12 w-[calc(100%-1.5rem)] items-center overflow-hidden rounded-xl px-3 text-slate-500 transition-[background-color,color] duration-200 ease-in-out hover:bg-white hover:text-slate-900"
    >
        <button
            type="button"
            class="relative flex w-full items-center overflow-hidden bg-transparent p-0 text-inherit"
            (click)="menu.toggle($event)"
            (keypress)="menu.toggle($event)"
        >
            <span
                class="absolute top-1/2 flex -translate-y-1/2 items-center justify-center text-center text-sm font-semibold text-inherit transition-[left,transform,width] duration-200 ease-in-out"
                [ngClass]="isExtended ? 'left-0 w-6' : 'left-1/2 w-6 -translate-x-1/2'"
            >
                {{ currentLocale | uppercase }}
            </span>
            <span
                class="min-w-0 overflow-hidden whitespace-nowrap text-start text-base font-medium transition-opacity duration-150 ease-in-out"
                [ngClass]="isExtended ? 'ml-10 flex-1 truncate pr-2 opacity-100' : 'w-0 opacity-0'"
            >
                {{ localizedLanguages[currentLocale] }}
                <fa-icon class="ml-2" [icon]="faCaretDown" />
            </span>
        </button>
    </div>
} @else {
    <button type="button" [class]="internalOptions.textClassMini" (click)="menu.toggle($event)" (keypress)="menu.toggle($event)">
        {{ currentLocale | uppercase }}
        <fa-icon class="ml-2" [icon]="faCaretDown" />
    </button>
}
